/* global google */
import mediaCheck from './mediaCheck';
import getAvailableServices from './getAvailableServices';
import getDistanceLabel from './getDistanceLabel';
import { BREAKPOINT } from '../constants/map';
import {
    ENDPOINT_SEND_FEEDBACK,
} from '../constants/apiEndpoints';
import $ from 'jquery';

export const openInfoWindow = (
    activeMarker,
    userPos,
    map,
    infowindow,
    labels,
    services,
    language,
    onClose,
) => {
    if (
        Object.entries(activeMarker).length === 0
        || Object.entries(infowindow).length === 0
    ) {
        return;
    }
    infowindow.setContent(getInfoWindowContent(activeMarker, userPos, labels, services, language));
    infowindow.setPosition({
        lat: activeMarker.point.coordinates[1],
        lng: activeMarker.point.coordinates[0]
    });

    if (mediaCheck(`min-width: ${BREAKPOINT}px`)) {
        infowindow.open(map);
    }

    google.maps.event.clearListeners(infowindow, 'closeclick');
    if (onClose) {
        google.maps.event.addListener(infowindow, 'closeclick', onClose);
    }

    google.maps.event.addListenerOnce(infowindow, 'domready', function() {
        $('.InfoWindow__FeedbackButton').on('click', () => {
            $('.InfoWindow__Content').hide();
            $('.InfoWindow__FeedbackContainer').hide();
            $('.InfoWindow__Form').show();
            document.body.classList.add('feedback-active');

            infowindow.open(map);
            $('.InfoWindow__Form').on('submit', (e) => {
                e.preventDefault();
                const email = $('.InfoWindow__FormEmail').val();
                const feedback = $('.InfoWindow__FormFeedback').val();
                let machines = activeMarker.machines || [];
                machines = machines.sort((a, b) => a.machine_id - b.machine_id);
                let machineIds = machines.map(x => x.machine_id);
                $.post(ENDPOINT_SEND_FEEDBACK, { email: email, feedback: feedback, machineIds: machineIds.join() })
                    .done(() => {
                        $('.InfoWindow__FormContent').css({'opacity': '0', 'pointer-events': 'none'});
                        $('.InfoWindow__Message').text(labels.sendSuccess);
                    })
                    .fail(() => {
                        $('.InfoWindow__FormContent').css({'opacity': '0', 'pointer-events': 'none'});
                        $('.InfoWindow__Message').text(labels.sendFail);
                    })
            })
        })
    });
};

const getInfoWindowContent = (activeMarker, userPos, labels, services, language) => {
    const serviceLabelType = 'popup';
    let markerServices = [...activeMarker.services]
    const markerServicesIds = markerServices.map((service) => service.identifier)
    const currencies = activeMarker.currencies || [];
    const rates = activeMarker.rates || [];
    const rateIds = rates.map((rate) => rate.currency.toLowerCase())
    const missingRateIds = rateIds.filter((rateId) => !markerServicesIds.includes(rateId))

    missingRateIds.forEach((rateId) => {
        markerServices.push({
            available: false,
            identifier: rateId,
        })
    });

    const availableServices = getAvailableServices(
      markerServices, services, language, serviceLabelType
    );

    let machines = activeMarker.machines || [];
    machines = machines.sort((a, b) => a.machine_id - b.machine_id);
    let machineIds = machines.map(x => x.machine_id);
    let openingHours = '';

    // TODO: Remove below logic when realtime api is in production
    if (machines.length) {
        const machineWithOpeningHours = machines
            .filter(machine => machine.opening_hours !== '')
            .slice(-1)[0];

        if (machineWithOpeningHours) {
            openingHours = machineWithOpeningHours.opening_hours;
        }
    }

    let distance = null;
    if(userPos) {
        distance = getDistanceLabel(
            { lat: userPos.lat, lng: userPos.lng },
            { lat: activeMarker.point.coordinates[1], lng: activeMarker.point.coordinates[0] }
        );
    }

    if(activeMarker.opening_info) {
        openingHours = activeMarker.opening_info;
    }

    const isWithdrawalAvailable = activeMarker.services.find(service => service.identifier === 'withdrawal' && service.available);
    const isDepositAvailable = activeMarker.services.find(service => service.identifier === 'deposit' && service.available);

    const hasNFC = () => {
        const nfcService = activeMarker.services.find(service => service.identifier === 'NFC');
        return nfcService ? nfcService.available : false;
    }

    return `
    <div class="InfoWindow">
        <div class="InfoWindow__Header">
            <div class="InfoWindow__MachineId">
                <div>
                    ${labels.machineId}:&nbsp;
                    ${machines.map(x => `
                        <span class="${x.is_open === false ? 'InfoWindow__Info--Disabled' : ''}">${x.machine_id}</span>
                    `).join(',&nbsp;')}
                </div>
                <div>
                    ${hasNFC() ? `<div class="InfoWindow__NFC"></div>` : ''}
                </div>
            </div>
            ${activeMarker.address1}, ${activeMarker.address2 ? `${activeMarker.address2}, ` : ''}${activeMarker.city}
        </div>
        <div class="InfoWindow__Content">
        ${availableServices.withdrawalServices.length !== 0
        ? `
            <p class="InfoWindow__Info InfoWindow__Info--Withdrawal ${isWithdrawalAvailable ? '' : 'InfoWindow__Info--Disabled'}"><strong>${labels.withdrawal}:</strong> ${availableServices.withdrawalServices.join('')}</p>
        `
        : ''}
        ${availableServices.depositServices.length !== 0
        ? `
            <p class="InfoWindow__Info InfoWindow__Info--Deposit ${isDepositAvailable ? '' : 'InfoWindow__Info--Disabled'}"><strong>${labels.deposit}:</strong> ${availableServices.depositServices.join('')}</p>
        `
        : ''}
        ${!activeMarker.is_open
        ? `<p class="InfoWindow__Info InfoWindow__Info--Note">${labels.isClosed}</p>`
        : ''}
        ${distance
        ? `<p class="InfoWindow__Info"><strong>${labels.distanceToYou}:</strong> ${distance}</p>`
        : ''}
        ${rates.length > 0
        ? `<div class="InfoWindow__RateContainer"><h5 class="InfoWindow__Label">${labels.exchangeRates}:</h5>&nbsp;`
        : ''}
        ${activeMarker.rates
        ?
        '<div class="InfoWindow__RateContent">' +
        activeMarker.rates.map(rate => `
            <p class="InfoWindow__Info InfoWindow__Info--Rate">${rate.currency}: ${(rate.rate / rate.unit).toFixed(4)}</p>
        `).join('') + '</div>'
        : ''}
        ${activeMarker.rates && activeMarker.rates.length > 0
        ? `</div>`
        : ''}
        ${currencies.length > 0
        ? `<div class="InfoWindow__RateContainer">
          <h5 class="InfoWindow__Label">${labels.currencies}:</h5>&nbsp;
        <div class="InfoWindow__RateContent">` +
        activeMarker.currencies.map(value => `
            <p class="InfoWindow__Info InfoWindow__Info--Currency"><strong>${value.currency}:</strong> ${value.denomination}</p>
        `).join('') + `</div>
        </div>`
        : ''}
        ${openingHours !== ''
        ? `
            <p class="InfoWindow__Info InfoWindow__Info--Hours"><strong>${labels.businessHours}:</strong> ${openingHours}</p>
            `
        : ''}
        </div>
        <div class="InfoWindow__FeedbackContainer">
            <span class="InfoWindow__FeedbackButton" role="button">${labels.feedbackButton}</span>
        </div>
        <form class="InfoWindow__Form">
            <p class="InfoWindow__Message"></p>
            <div class="InfoWindow__FormContent">
                <h2 class="MobilePopup__FormTitle">${labels.feedbackHeading}</h2>
                <input
                    name="email"
                    class="InfoWindow__FormEmail"
                    placeholder=${labels.email}
                    type="email"
                    required
                />
                <textarea
                    name="feedback"
                    class="InfoWindow__FormFeedback"
                    required
                ></textarea>
                <input type="hidden" value=${machineIds.join()} />
                <input class="InfoWindow__FormButton button" type="submit" value=${labels.send} />
            </div>
        </form>
    </div>
    `;
};
